module.exports = __webpack_public_path__ + "static/curva-aprendizado-b9cb9cb97df0d3e9bff207bd50ce459b.png";